const player = {
	name: {
		firstname: 'Anthony',
		lastname: 'Cavuoti',
	},
	power: 50, //default is 50. For testing story use 9500
	gender: 'm',
	effectivness: 1,
	skill: 3,
	skillPoints: 1,
	energy: 10,
	sanity: 30,
	happyness: 1,
	cleanliness: 500,
	respectability: 5,
	anger: 0,
	wealth: 4,
	personality: 'curious',
	currentStation: 'rice',
	job: 'cook',
};

export default player;
